var map = {
	"./gift_btc@2x.png": 442,
	"./gift_ht@2x.png": 160,
	"./gift_money@2x.png": 443,
	"./gift_toss@2x.png": 161
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 441;


//////////////////
// WEBPACK FOOTER
// ./src/assets/gift ^\.\/gift_.*@2x\.png$
// module id = 441
// module chunks = 0